
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "SearchMedicalSchoolsResult": [
      "SearchMedicalSchoolsFailure",
      "SearchMedicalSchoolsSuccess"
    ],
    "ChangeEmailResult": [
      "ChangeEmailFailure",
      "ChangeEmailSuccess"
    ],
    "ConfirmEmailVerificationResult": [
      "ConfirmEmailVerificationFailure",
      "ConfirmEmailVerificationSuccess"
    ],
    "LoginWithIdTokenResult": [
      "LoginWithIdTokenFailure",
      "LoginWithIdTokenSuccess"
    ],
    "LoginWithPasswordResult": [
      "LoginWithPasswordFailure",
      "LoginWithPasswordSuccess"
    ],
    "LoginWithRefreshTokenResult": [
      "LoginWithRefreshTokenFailure",
      "LoginWithRefreshTokenSuccess"
    ],
    "RecoverEmailResult": [
      "RecoverEmailFailure",
      "RecoverEmailSuccess"
    ],
    "RegisterAcquisitionUserResult": [
      "RegisterAcquisitionUserFailure",
      "RegisterAcquisitionUserSuccess"
    ],
    "RegisterQualifiedTrafficUserResult": [
      "RegisterQualifiedTrafficUserFailure",
      "RegisterQualifiedTrafficUserSuccess"
    ],
    "RegisterUserResult": [
      "RegisterUserFailure",
      "RegisterUserSuccess"
    ],
    "ResetPasswordResult": [
      "ResetPasswordFailure",
      "ResetPasswordSuccess"
    ],
    "SendEmailVerificationResult": [
      "SendEmailVerificationFailure",
      "SendEmailVerificationSuccess"
    ],
    "SetAcquisitionParamsResult": [
      "SetAcquisitionParamsFailure",
      "SetAcquisitionParamsSuccess"
    ]
  }
};
      export default result;
    